<div class="highlighted-products">
  <air-title [title]="content.title" [region]="region" [isFirst]="isFirst"></air-title>
  <air-product-category-list *ngIf="hasCategory" (categoryClick)="onCategoryClick($event)"></air-product-category-list>

  <ng-container *ngIf="products && !loading; else loadingBlock">
    <ul class="product-list grid">
      <ng-container *ngFor="let p of products; let i = index">
        <li
          class="product-list__item col-3--md col-4--sm"
          [ngClass]="{
            'product-list__item--large col-6': !noLargeItems && i < 2,
            'col-3': noLargeItems || i >= 2,
            'product-list__item--first': noLargeItems ? i === 0 : i === 2
          }"
        >
          <air-product-card
            *ngIf="!isCustomCard(p.product)"
            [product]="$any(p.product)"
            [isLarge]="!noLargeItems && i < 2"
            [isDescriptionHidden]="isDescriptionHidden"
            [userEventSource]="userEventSource"
            [userEventObject]="p.userEventObject"
          ></air-product-card>
          <air-custom-card
            *ngIf="isCustomCard(p.product)"
            [card]="$any(p.product)"
            [isLarge]="!noLargeItems && i < 2"
            [isDescriptionHidden]="isDescriptionHidden"
            [userEventSource]="userEventSource"
            [userEventObject]="p.userEventObject"
          ></air-custom-card>
        </li>
      </ng-container>
    </ul>
  </ng-container>

  <ng-template #loadingBlock>
    <ul class="product-list grid loading">
      <ng-container *ngFor="let skeleton of [] | range: 6; let i = index">
        <li
          class="product-list__item col-3--md col-4--sm"
          [ngClass]="{ 'product-list__item--large col-6': i < 2, 'col-3': i >= 2, 'product-list__item--first': i === 2 }"
        >
          <air-skeleton-card
            [additionalClasses]="{ 'card--product': true, 'card--product--large': i < 2 }"
            [isLarge]="i < 2"
          ></air-skeleton-card>
        </li>
      </ng-container>
    </ul>
  </ng-template>
</div>
